import "./App.css";
import QuranVerses from "./components/quranVerses/QuranVerses";
function App() {
  return (
    <>
      <QuranVerses />
    </>
  );
}

export default App;
